import { getCompanyName, getLogo, getUrl } from 'common/helpers/miscHelper';

const CheckoutLogo = (props) => {
  const { settings } = props;
  const logo = getLogo(settings);
  if (!logo) {
    return <div className="c7-checkout-template__logo">Your Logo Here</div>;
  }
  return (
    <div className="c7-checkout-template__logo">
      <a href={getUrl(settings)}>
        <img src={logo} alt={getCompanyName(settings)} />
      </a>
    </div>
  );
};
export default CheckoutLogo;
